/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { SwimlaneListFactory } from 'src/app/common/fancy-firebase-ticket/services/ticket-factories';
import { Swimlanes } from 'src/app/app-data/state/Swimlanes';
import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';

import firebase from 'firebase/compat/app';

@Injectable({
	providedIn: 'root',
})
export class FancyFirebaseSwimlanesApiBuilder {
	constructor(private swimlaneListFactory: SwimlaneListFactory) {}

	public getSwimlanesApi<T extends FancyAction>(
		projectId: string,
		planId: string,
		extraObservable: Observable<T>
	) {
		const swimlaneListPath = fancyFirebaseGetters.getSwimlanesPath(projectId, planId);
		const swimlaneList = this.swimlaneListFactory.create(
			fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(swimlaneListPath, projectId)
		);
		const swimlanes = new Swimlanes(swimlaneList);

		swimlaneList.addSupplementalObservable(extraObservable);

		return swimlanes;
	}
}
